/* eslint-disable react/prop-types */
/**
 * ThemePreviewNotice — "you are previewing a look only you can see", on every
 * page, while an admin's preview differs from the app-wide look.
 *
 * Without it the preview is invisible outside Admin → Appearance: an admin
 * who previews Ledger and wanders off sees Ledger everywhere and can fairly
 * conclude it is live for everyone.
 *
 * Fixed to the bottom-left corner so it never moves the page's own layout.
 * Candidate for promotion to wig-react-library alongside WigThemeSetting if a
 * second app adopts the Appearance screen.
 */
import { Button, Space, Typography } from "antd";
import { WIG_THEME_PRESETS } from "@warwick-investment-group/wig-react-library";

const { Text } = Typography;

const labelOf = (preset) =>
  (WIG_THEME_PRESETS || []).find((p) => p.value === preset)?.label || preset;

const ThemePreviewNotice = ({ preview, live, onStop }) => {
  if (!preview || preview === live) return null;
  return (
    <div
      role="status"
      data-testid="theme-preview-notice"
      style={{
        position: "fixed",
        left: 16,
        bottom: 16,
        zIndex: 1100,
        padding: "8px 12px",
        borderRadius: 6,
        background: "#262626",
        color: "#ffffff",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
      }}
    >
      <Space size="middle">
        <Text style={{ color: "inherit" }}>
          Previewing {labelOf(preview)}: only you see this. Everyone else sees{" "}
          {labelOf(live)}.
        </Text>
        <Button size="small" onClick={() => onStop(null)}>
          Stop preview
        </Button>
      </Space>
    </div>
  );
};

export default ThemePreviewNotice;
